export const PageLayout = ({ children, className = '', withFormLayout = true, ...props }) => {
  return (
    <div
      className={`flex justify-center max-w-full bg-white rounded-b-xl py-6 px-6 md:py-10 md:px-24 ${className}`}
      {...props}>
      {withFormLayout ? <FormLayout>{children}</FormLayout> : <>{children}</>}
    </div>
  );
};

export const WidePageLayout = ({ children, className = '', ...props }) => (
  <div
    className={`flex flex-col w-full items-center justify-center max-w-full bg-white rounded-b-xl py-6 px-6 md:py-10 md:px-24 ${className}`}
    {...props}>
    {children}
  </div>
);

export const FormLayout = ({ children, className = '', ...props }) => {
  return (
    <div
      className={`flex flex-col items-center w-full gap-y-6 px-2 max-w-lg ${className}`}
      {...props}>
      {children}
    </div>
  );
};
